import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=034a0d18&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"
import style0 from "./Stats.scss?vue&type=style&index=0&id=034a0d18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a0d18",
  null
  
)

export default component.exports